import Accordion from '@/components/accordion-collapse/accordion/accordion.component'
import FirebaseConnect, { Provider } from '@/components/firebase-connect/firebase-connect.component'
import { SocialNetworkProfile } from '@/interfaces/social-network-profiles.interface'
import onDetectIosApp from '@/observables/on-detect-ios-app.observable'
import onSocialNetworkConnection from '@/observables/social-network-connection.observable'
import ProxyAuthService from '@/services/proxy-auth/proxy-auth.service'
import defaultUser from '@assets/img/jpg/avatar.jpg'
import defaultImage from '@assets/img/jpg/image.jpg'
import loginBgPngDesktop from '@assets/img/png/login-bg-png-desktop.png'
import loginBgPngMobile from '@assets/img/png/login-bg-png-mobile.png'
import simbolPng from '@assets/img/png/simbol.png'
import simbolSvg from '@assets/img/svg/simbol.svg'
import squidFooterSvg from '@assets/img/svg/squid-footer.svg'
import squidSvg from '@assets/img/svg/squid.svg'
import loginBg from '@assets/img/webp/login-bg.webp'
import Collapse from '@components/accordion-collapse/collapse/collapse.component'
import BannerIdeas from '@components/banner-ideas/banner-ideas.component'
import Banner from '@components/banner/banner.component'
import BarChart from '@components/bar-chart/bar-chart.component'
import BorderWithIcon from '@components/border-with-icon/border-with-icon.component'
import ButtonBack from '@components/buttons/button-back/button-back.component'
import ButtonCopyText from '@components/buttons/button-copy-text/button-copy-text.component'
import Button from '@components/buttons/button/button.component'
import Callout from '@components/callout/callout.component'
import CardPaymentValue from '@components/card-payment-value/card-payment-value.component'
import PaymentStatus from '@components/card-payment-value/components/payment-status/payment-status.component'
import CardToCopy from '@components/card-to-copy/card-to-copy.component'
import Carousel from '@components/carousel/carousel.component'
import CategoriesFormSocialNetworkComponent from '@components/categories-form-social-network/categories-form-social-network.component'
import ChartDoughnut from '@components/chart-doughnut/chart-doughnut.component'
import ChartHorizontalBarChartjs from '@components/chart-horizontal-bar-chartjs/chart-horizontal-bar-chartjs.component'
import ChartHorizontalBar from '@components/chart-horizontal-bar/chart-horizontal-bar.component'
import CircleCompletation from '@components/circle-completation/circle-completation.component'
import ErrorBoundary from '@components/error-bundary/error-boundary.component'
import IncompletePaymentData from '@components/incomplete-payment-data/incomplete-payment-data.component'
import InfinityScroll from '@components/infinity-scroll/infinity-scroll.component'
import InputBirthday from '@components/inputs/input-birthday/input-birthday.component'
import InputCountries from '@components/inputs/input-countries/input-countries.component'
import InputDate from '@components/inputs/input-date/input-date.component'
import InputDigits from '@components/inputs/input-digits/input-digits.component'
import InputDocumentCnpj from '@components/inputs/input-document-cnpj/input-document-cnpj.component'
import InputDocumentCpf from '@components/inputs/input-document-cpf/input-document-cpf.component'
import InputDocumentInternational from '@components/inputs/input-document-international/input-document-international.component'
import InputDocumentRut from '@components/inputs/input-document-rut/input-document-rut.component'
import InputFile from '@components/inputs/input-file/input-file.component'
import InputGenders from '@components/inputs/input-genders/input-genders.component'
import InputMedia from '@components/inputs/input-media/input-media.component'
import InputName from '@components/inputs/input-name/input-name.component'
import InputPassword from '@components/inputs/input-password/input-password.component'
import InputPhone from '@components/inputs/input-phone/input-phone.component'
import InputRaces from '@components/inputs/input-races/input-races.component'
import InputStates from '@components/inputs/input-states/input-states.component'
import InputZipCode from '@components/inputs/input-zipcode/input-zipcode.component'
import Input from '@components/inputs/input/input.component'
import MultiSelect from '@components/inputs/multi-select/multi-select.component'
import Select from '@components/inputs/select/select.component'
import SelectorImage from '@components/inputs/selector-image/selector-image.component'
import Selector from '@components/inputs/selector/selector.component'
import LanguageSelector from '@components/language-selector/language-selector'
import Loader from '@components/loader/loader.component'
import LogoFooter from '@components/logo-footer/logo-footer.component'
import Logo from '@components/logo/logo.component'
import LPList from '@components/lp-list/lp-list.component'
import MenuOptions from '@components/menu-options/menu-options.component'
import ModalAcceptanceContract from '@components/modals/modal-acceptance-contract/modal-acceptance-contract.component'
import ModalContract from '@components/modals/modal-contract/modal-contract.component'
import ModalUnsaveData, { InfoChanged } from '@components/modals/modal-unsave-data/modal-unsave-data.component'
import ModalVinculateSocialNetwork from '@components/modals/modal-vinculate-social-network/modal-vinculate-social-network'
import Modal from '@components/modals/modal/modal.component'
import NextPayments from '@components/next-payments/next-payments.component'
import Overlay from '@components/overlay/overlay.component'
import Pagination from '@components/pagination/pagination.component'
import SocialConnect from '@components/social-connect/social-connect.component'
import SocialItem from '@components/social-item/social-item.component'
import Steps from '@components/steps/steps.component'
import SubCategoriesFormSocialNetworkComponent from '@components/sub-categories-form-social-network/sub-categories-form-social-network.component'
import Tabs from '@components/tabs/tabs.component'
import Tag from '@components/tag/tag.component'
import TimeLine from '@components/timeline/timeline.component'
import TinyCalendar from '@components/tiny-calendar/tiny-calendar.component'
import Tip from '@components/tip/tip.component'
import ToggleTheme, { ThemeObservable } from '@components/toggle-theme/toggle-theme.component'
import ErrorMessage from '@enums/error-messages.enum'
import ActivateProfileHelper from '@helpers/activate-profile.helper'
import CategoriesHelper from '@helpers/categories.helper'
import ColorIconHelper from '@helpers/colorIcon.helper'
import ColorsHelper from '@helpers/colors.helper'
import DataLayerHelper from '@helpers/data-layer.helper'
import DataHelper from '@helpers/data.helper'
import Emitter from '@helpers/event-emitter.helper'
import JwtHelper from '@helpers/jwt.helper'
import localForageHelper from '@helpers/localforage.helper'
import LogHelper from '@helpers/log.helper'
import NumbersHelper from '@helpers/numbers.helper'
import ObjectHelper from '@helpers/object.helper'
import OldHelper from '@helpers/old.helper'
import StringsHelper from '@helpers/strings.helper'
import ToastHelper from '@helpers/toast.helper'
import UserHelper from '@helpers/user.helper'
import ValidatorHelper from '@helpers/validator.helper'
import useImageLoader from '@hooks/use-image-loader/useImageLoader.hook'
import useLinkSocialNetwork from '@hooks/use-link-social-network/use-link-social-network.hook'
import useMessage from '@hooks/use-message/use-message.hook'
import { useRect } from '@hooks/use-rect/use-rect-hook'
import useSocialNetworkInformationActions from '@hooks/use-social-network-information-actions/use-social-network-information-actions.hook'
import Bank, { BankResponse } from '@interfaces/bank.interface'
import CampaignQuantityBySocialNetwork from '@interfaces/campaign-quantity-by-social-network.interface'
import Campaign, { Activation, Nps, Payments, SuggestionRules } from '@interfaces/campaign.interface'
import Category from '@interfaces/category.interface'
import Checkout from '@interfaces/checkouts.interface'
import PostVidaDeInfluencer, {
  AlternativeContent,
  AlternativeRecipe,
  Author,
  Content,
  ContentDraft,
  Data,
  Identifier,
  Metadata,
  Recipe,
  Response,
  Statuses,
} from '@interfaces/community-article.interface'
import Country from '@interfaces/country.interface'
import CreatorProfileInstagram from '@interfaces/creator-profile.interface'
import Environment from '@interfaces/environment.interface'
import FitRequirements, { FitNetwork, FitProfile, Fits } from '@interfaces/fit-requirements.interface'
import Gamification from '@interfaces/gamification.interface'
import HubConfig from '@interfaces/hub-config.interface'
import MediaPreApproval from '@interfaces/media-pre-approval.interface'
import Media, { CampaignUserMedias } from '@interfaces/media.interface'
import MediaKit, {
  Analytics as AnalyticsMediaKit,
  Brand as BrandMediaKit,
  ChartDatasetClicks as ChartDatasetClicksMediaKit,
  Comment as CommentsInstagram,
  Communication as CommunicationMediaKit,
  Purpose as PurposeMediaKit,
  TargetAudience as TargetAudienceMediaKit,
  WhoAnnounced as WhoAnnouncedMediaKit,
  WhoDoes as WhoDoesMediaKit,
} from '@interfaces/mediakit.interface'
import CampaignStatisticsUser, { Classification, Metric, MetricsDetails, TotalClicks, UniqueClicks } from '@interfaces/metrics.interface'
import MySquid from '@interfaces/my-squid.interface'
import Notice from '@interfaces/notices.interface'
import Notification, { PushNotificationInfos } from '@interfaces/notification.interface'
import Payment, { HistoryTransaction, InfluencerPayment, InfluencerTransaction, NFSImported, Nf } from '@interfaces/payment.interface'
import Prizes from '@interfaces/prizes.interface'
import ProfileCompleteness from '@interfaces/profile-completeness.interface'
import QuestionGroupedInterface, {
  AnswersFormated,
  AnswersPayload,
  Labels,
  Option,
  Question,
  TypeQuestion,
} from '@interfaces/questions.interface'
import Ranking from '@interfaces/ranking.interface'
import ShareReferral from '@interfaces/referral.interface'
import Schedule, { ScheduleItem } from '@interfaces/schedule.interface'
import { SocialNetworksAvailables, SocialNetworksInfoParams } from '@interfaces/socialnetworks.interface'
import State from '@interfaces/state.interface'
import toastConfig from '@interfaces/toast.interface'
import UserInCampaign, { HasProfile, UserInDetails } from '@interfaces/user-in-campaign.interface'
import User, {
  Cache,
  ImpersonateInfo,
  Instagram,
  LandingPage,
  LandingPagesInfos,
  Page,
  ProfileAdditionalInfo,
  Profilewhitelabel,
  StatusProvider,
  TikTok,
  Twitter,
  UserAuth,
  Youtube,
} from '@interfaces/user.interface'
import { Video } from '@interfaces/video.interface'
import ZipCodeResponse from '@interfaces/zipcode.interface'
import UTMS from '@interfaces/utms.interface'
import NavigationSingleLayout from '@layouts/navigation-single/navigation-single.layout'
import InsideNavigationParcelComponent from '@layouts/navigation/components/inside-navigation-parcel/inside-navigation-parcel.component'
import NavigationLayout, { MenuItemNavigation } from '@layouts/navigation/navigation.layout'
import onCategoriesChange, { onLoadingCategories } from '@observables/categories.observable'
import onConfigChange from '@observables/config.obvervable'
import onDefaultLayoutShowFooterChange from '@observables/default-layout-show-footer.observable'
import onDefaultLayoutShowHeaderChange from '@observables/default-layout-show-header.observable'
import onEnvironmentChange from '@observables/environment.observable'
import onFirebaseConfigChange from '@observables/firebase-config.observable'
import onGeneralLoaderChange, { AppLoaderChange } from '@observables/general-loader.observable'
import onLangChange from '@observables/on-lang-change.observable'
import onProfileCompletenessChange from '@observables/profile.completeness.observable'
import onProfilePercentageChange from '@observables/profile.percentage.observable'
import onUserChange from '@observables/user.observable'
import { onModalCreatorsInsightsObservable } from './observables/on-modal-creators-insights.observable'
import AlfredService from '@services/alfred/alfred.service'
import BatmanService from '@services/batman/batman.service'
import ClarityService from '@services/clarity/clarity.service'
import DakenService from '@services/daken/daken.service'
import EdnaService from '@services/edna/edna.service'
import ElektraService from '@services/elektra/elektra.service'
import FinancialOperationService from '@services/financial-operation/financial-operation.service'
import GeneralListingsService from '@services/general-listings/general-listings.service'
import HeimdallService from '@services/heimdall/heimdall.service'
import HelaService from '@services/hela/hela.service'
import HubCampaignsService from '@services/hub-campaigns/hub-campaigns.service'
import HubCoreService from '@services/hub-core/hub-core.service'
import IBGEService from '@services/ibge/ibge.service'
import JessicaJonesService from '@services/jessica-jones/jessica-jones.service'
import LexLuthorService from '@services/lex-luthor/lex-luthor.service'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import MariaHillService from '@services/mariahill/mariahill.service'
import MrFantasticService from '@services/mr-fantastic/mr-fantastic.service'
import NpsService from '@services/nps/nps.service'
import ReferralsService from '@services/referrals/referrals.service'
import SheHulkService from '@services/shehulk/shehulk.service'
import SpidermanService from '@services/spiderman/spiderman.service'
import TioPatinhasService from '@services/tio-patinhas/tio-patinhas.service'
import VidaDeInfluencerService from '@services/vida-de-influencer/vida-de-influencer.service'
import VisionService from '@services/vision/vision.service'
import ZeCariocaService from '@services/ze-carioca/ze-carioca.service'
import ModalVinculate from './components/modals/modal-vinculate/modal-vinculate.component'
import useDebounce from './hooks/use-debounce/use-debounce.hook'
import useThrottle from './hooks/use-throttle/use-throttle.hook'
import i18n from './i18n.shared'
import * as Mocks from './mocks'
import { useLanguage } from './hooks/use-language/use-language.hook'
import { useMediaQuery } from './hooks/use-media-query/use-media-query.hook'
import { LanguageDropdown } from './components/language-dropdown/language-dropdown.component'
import { useCreatorsInsights } from './hooks/use-creators-insights/use-creators-insights.hook'

// Types
export type {
  Activation,
  AlternativeContent,
  AlternativeRecipe,
  AnalyticsMediaKit,
  AnswersFormated,
  AnswersPayload,
  Author,
  Bank,
  BankResponse,
  BrandMediaKit,
  Cache,
  Campaign,
  CampaignQuantityBySocialNetwork,
  CampaignStatisticsUser,
  CampaignUserMedias,
  Category,
  ChartDatasetClicksMediaKit,
  Checkout,
  Classification,
  CommentsInstagram,
  CommunicationMediaKit,
  Content,
  ContentDraft,
  Country,
  CreatorProfileInstagram,
  Data,
  Environment,
  FitNetwork,
  FitProfile,
  FitRequirements,
  Fits,
  Gamification,
  HasProfile,
  HistoryTransaction,
  HubConfig,
  Identifier,
  ImpersonateInfo,
  InfluencerPayment,
  InfluencerTransaction,
  InfoChanged,
  Instagram,
  Labels,
  LandingPage,
  LandingPagesInfos,
  Media,
  MediaPreApproval,
  MenuItemNavigation,
  Metadata,
  Metric,
  MetricsDetails,
  MySquid,
  NFSImported,
  Nf,
  Notice,
  Notification,
  Nps,
  Option,
  Page,
  Payment,
  Payments,
  PostVidaDeInfluencer,
  Prizes,
  ProfileCompleteness,
  Profilewhitelabel,
  Provider,
  PurposeMediaKit,
  PushNotificationInfos,
  Question,
  QuestionGroupedInterface,
  Ranking,
  Recipe,
  Response,
  Schedule,
  ScheduleItem,
  ShareReferral,
  SocialNetworkProfile,
  SocialNetworksAvailables,
  SocialNetworksInfoParams,
  State,
  StatusProvider,
  Statuses,
  SuggestionRules,
  TargetAudienceMediaKit,
  TikTok,
  TotalClicks,
  Twitter,
  TypeQuestion,
  UniqueClicks,
  User,
  UserAuth,
  UserInCampaign,
  UserInDetails,
  Video,
  WhoAnnouncedMediaKit,
  WhoDoesMediaKit,
  Youtube,
  ZipCodeResponse,
  UTMS,
  toastConfig,
}
// Enums
export { ErrorMessage }
// Types as class
export { MediaKit, ProfileAdditionalInfo }
// Services
export {
  AlfredService,
  BatmanService,
  CategoriesHelper,
  ClarityService,
  DakenService,
  EdnaService,
  ElektraService,
  FinancialOperationService,
  GeneralListingsService,
  HeimdallService,
  HelaService,
  HubCampaignsService,
  HubCoreService,
  IBGEService,
  JessicaJonesService,
  LexLuthorService,
  LogService,
  MainService,
  MariaHillService,
  MrFantasticService,
  NpsService,
  ObjectHelper,
  OldHelper,
  ProxyAuthService,
  ReferralsService,
  SheHulkService,
  SpidermanService,
  TioPatinhasService,
  VidaDeInfluencerService,
  VisionService,
  ZeCariocaService,
}
// Helpers
export {
  ActivateProfileHelper,
  ColorIconHelper,
  ColorsHelper,
  DataHelper,
  DataLayerHelper,
  Emitter,
  JwtHelper,
  LogHelper,
  NumbersHelper,
  StringsHelper,
  ToastHelper,
  UserHelper,
  ValidatorHelper,
  localForageHelper,
}
// Mocks
export { Mocks }
// Hooks
export {
  useDebounce,
  useImageLoader,
  useLinkSocialNetwork,
  useMessage,
  useRect,
  useSocialNetworkInformationActions,
  useThrottle,
  useLanguage,
  useMediaQuery,
  useCreatorsInsights,
}
// Components
export {
  Accordion,
  Banner,
  BannerIdeas,
  BarChart,
  BorderWithIcon,
  Button,
  ButtonBack,
  ButtonCopyText,
  Callout,
  CardPaymentValue,
  CardToCopy,
  Carousel,
  CategoriesFormSocialNetworkComponent,
  ChartDoughnut,
  ChartHorizontalBar,
  ChartHorizontalBarChartjs,
  CircleCompletation,
  Collapse,
  ErrorBoundary,
  FirebaseConnect,
  IncompletePaymentData,
  InfinityScroll,
  Input,
  InputBirthday,
  InputCountries,
  InputDate,
  InputDigits,
  InputDocumentCnpj,
  InputDocumentCpf,
  InputDocumentInternational,
  InputDocumentRut,
  InputFile,
  InputGenders,
  InputMedia,
  InputName,
  InputPassword,
  InputPhone,
  InputRaces,
  InputStates,
  InputZipCode,
  InsideNavigationParcelComponent,
  LPList,
  LanguageSelector,
  LanguageDropdown,
  Loader,
  Logo,
  LogoFooter,
  MenuOptions,
  Modal,
  ModalAcceptanceContract,
  ModalContract,
  ModalUnsaveData,
  ModalVinculate,
  ModalVinculateSocialNetwork,
  MultiSelect,
  NextPayments,
  Overlay,
  Pagination,
  PaymentStatus,
  Select,
  Selector,
  SelectorImage,
  SocialConnect,
  SocialItem,
  Steps,
  SubCategoriesFormSocialNetworkComponent,
  Tabs,
  Tag,
  TimeLine,
  TinyCalendar,
  Tip,
  ToggleTheme,
}
// Observables
export {
  AppLoaderChange,
  ThemeObservable,
  onCategoriesChange,
  onConfigChange,
  onDefaultLayoutShowFooterChange,
  onDefaultLayoutShowHeaderChange,
  onDetectIosApp,
  onEnvironmentChange,
  onFirebaseConfigChange,
  onGeneralLoaderChange,
  onLangChange,
  onLoadingCategories,
  onProfileCompletenessChange,
  onProfilePercentageChange,
  onSocialNetworkConnection,
  onUserChange,
  onModalCreatorsInsightsObservable,
}
// Images
export { defaultImage, defaultUser, loginBg, loginBgPngDesktop, loginBgPngMobile, simbolPng, simbolSvg, squidFooterSvg, squidSvg }
// Layouts
export { NavigationLayout, NavigationSingleLayout }

// Global loadings
onLangChange.subscribe((lang: 'pt' | 'en' | 'es') => {
  i18n.changeLanguage(lang)
})
